import React from 'react';
import { GridContainer, Grid } from '../../../shared/grid';
import '../FieldSample.scss';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';

type NoSamplesOnSiteProps = {
    onAddNewSampleClick: any,
    site:any
}

export const NoSamplesOnSite: React.FC<NoSamplesOnSiteProps> = ({onAddNewSampleClick, site}) => {

    return (
        <GridContainer className="removePadding">
            <Grid row gap="md" className='page-heading'>
                <Grid
                    desktop={{ col: 12 }}
                    style={{paddingTop: '2.5%', marginLeft: '1%', marginBottom: '2.5%'}}
                    className="display-flex flex-row flex-align-center flex-justify"
                >    
                    <span className="font-sans-sm text-bold"> 0 Samples have been collected at this site for the selected filters.</span>
                    
                </Grid>
                <Grid style={{marginLeft: '1%', marginBottom: '2.5%'}}>
                    {
                        !site?.siteStatus.includes('Inactive') &&
                        <Button variant="outlined" onClick={onAddNewSampleClick} style={{ textTransform: 'none'}}><AddIcon fontSize='small'/>New Sample</Button>
                    }
                </Grid>
            </Grid>
        </GridContainer>
    )
}